
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/babybooom/privacy_policies",
      function () {
        return require("private-next-pages/babybooom/privacy_policies/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/babybooom/privacy_policies"])
      });
    }
  